var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreencheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    fill: "#01AA3A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 104,
    height: 104,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAB+ElEQVRoge3Yz4tNYRzH8XuNminG758bmRilKcVfoJvYWoiVUjaymj/hlvwBNvIjO0VSzIqNkKKU0khJhrIg1GhkYWTmZXHu5dxx585zzr3mmcXzXp/n+3l/OqfnPOdUKolEIpFIJBItYAR3cQ4DsX0KgSF88Jcn2BDbKwhsxCv/8hLbYvt1BKvwrI18k/cYie3ZFvTjXgf5Jm9Rje3bApbhRoA8fFyKBc4Hyk/jQGzfFlAPlJ/Bsdi+LeBUoDyMdhO0Eit66F7BEfwKlD/TTVAN3zGFwz2Sr+FHoPylboKG8CU3bBb1LuX34Gug/BiWlw0axIt5Bl8sMxg7ZNtgCA+UPQPJ9uWxBQLuYLDAzE14HSg/jrWl5Btho4FBT7E5YN5qPA+cOYGtpeUbgVcCw+AddneYNSB7HEL4hJ1dyTdCt+NNgRKT2N9mTh9uBc74hn1dy+fC1+FhgRLTOJ5bX8XlAmsP9kw+J9GPqwVKzMqOBlWcDVwzg6M9l8+VKCLT5HGBa0//N/k5RU7IbnUvqS+KfK5ETfhbdCEuLKp8rsSw8BfSfNxGX5QCjRLr8aik/H1L4TeJbIe6VlB+HGtiu/9BtkOFflFNYEts57bgJH52kP+MXbE9O4JDso+euUxib2y/IGTn/euyQ9kUbmI4tlcikUgkEkua33l7CjOmfj7CAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.02b5321a3e822ff431b1b13490d968a4.svg";
export { ForwardRef as ReactComponent };